<div class="border border-grey-lighter rounded-xl p-4">
	<app-create-company-side-form
		label="Add law firm"
		[minify]="true"
		(onSubmit)="onSubmit($event)"
		(onCancel)="_onCancel()"
		[name]="name"
		[company]="lawFirm"
	></app-create-company-side-form>
</div>
